import { useNavigate } from 'react-router-dom';

export default function LectureTabNav({ lectureId, active }) {
  const navigate = useNavigate();

  const TABS = [
    { key: 'detail', label: '강의상세정보', url: `/master/lecture/${lectureId}` },
    { key: 'apply', label: '신청관리', url: `/master/lectureApply/${lectureId}` },
    { key: 'student', label: '수강생관리', url: `/master/lectureStudent/${lectureId}` },
    { key: 'attend', label: '출결관리', url: `/master/lectureAttend/${lectureId}` },
    { key: 'invoice', label: '세금계산서관리', url: `/master/lectureInvoice/${lectureId}` },
  ];

  return (
    <div className="tab-wrap-btn">
      <ul>
        {TABS.map(tab => (
          <li key={tab.key} className={active === tab.key ? 'on' : ''}>
            <button type="button" onClick={() => navigate(tab.url)}>
              {tab.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
